import firebase from 'firebase';
import { useCollectionData } from 'react-firebase-hooks/firestore';
import { ResourceHikeErrorEvent } from 'services/hitchit/types/hike/HikeErrorEvents';
import { Modal, Button, Col, Alert } from 'antd';
import capitalize from 'components/utils/capitalize';
import React from 'react';

import { ErrorResourceResultStatus } from 'services/hitchit/types/hike/HikeEvents';

export const ResourceError = ({
  hikeId,
  triggerEventId,
  status,
  error,
  msg,
  resourceType,
}: {
  hikeId: string;
  triggerEventId: string;
  status: ErrorResourceResultStatus;
  error?: string;
  msg: string;
  resourceType: string;
}): JSX.Element => {
  const [errorEvents, , errorFromQuery] = useCollectionData<ResourceHikeErrorEvent>(
    hikeId && triggerEventId
      ? firebase
          .firestore()
          .collection('hikes')
          .doc(hikeId)
          .collection('errorEvents')
          .where('type', '==', 'resource')
          .where('event.triggerEventId', '==', triggerEventId)
          .where('event.resource', '==', resourceType)
      : undefined
  );

  if (errorFromQuery) {
    console.error(errorFromQuery.message);
    // Sentry.captureException(error.message);
    // return { triggerEvents: [] };
  }
  return (
    <Col>
      <Alert
        message={capitalize(resourceType)}
        showIcon
        description={capitalize(msg)}
        type={status}
        action={
          <Button
            size="small"
            danger
            onClick={() =>
              Modal.info({
                title: capitalize(msg),
                content: (
                  <>
                    {errorEvents && errorEvents.length > 0 ? (
                      <>
                        <h3>Possible solutions</h3>
                        {errorEvents.map(({ event: { reasons } }) => {
                          return reasons.map((reason: string) => <p key={reason}>{reason}</p>);
                        })}
                      </>
                    ) : null}
                    {error && (
                      <>
                        <h3>Error details</h3>
                        <p>{error}</p>
                      </>
                    )}
                  </>
                ),
              })
            }
          >
            Detail
          </Button>
        }
      />
    </Col>
  );
};
